<template>
  <div class="flex flex-col gap-2 mt-2">
    <!-- <reaction-mate :reply="reply" /> -->
    <div class="flex w-full justify-between items-end">
      <div class="flex gap-2 flex-wrap">
        <button
          class="btn btn-xs font-normal rounded"
          @click.stop="replyStore.popEmoji(reply!)"
        >
          <i class="iconify mingcute--thumb-up-line" />
        </button>
        <reaction-counter :reply="reply" />
      </div>
      <!-- <div class="flex gap-1 items-center">
        <div
          class="btn btn-xs btn-ghost btn-square"
          @click.stop="onReplyActionClick"
        >
          <i class="iconify mingcute--more-1-line" />
        </div>
      </div> -->
    </div>

    <!-- <moment-actions v-model:show="showActions" :reply="reply" /> -->
  </div>
</template>

<script lang="ts" setup>
import { useReply } from "@/stores/reply";
import { Reply } from "@/types/entity";
import { PropType, ref } from "vue";

defineProps({
  reply: {
    type: Object as PropType<Reply>,
    required: true,
  },
});

const replyStore = useReply();

const showActions = ref(false);
const onReplyActionClick = () => {
  showActions.value = true;
};
</script>
